@charset "UTF-8";

/* src/app/core/layout/footer/footer.component.scss */
.consent-text {
  font-size: 16px;
}
@media (min-width: 2560px) {
  .consent-text {
    font-size: 19.2px;
  }
}
@media (min-width: 3000px) {
  .consent-text {
    font-size: 23.04px;
  }
}
.font-xxsmall {
  font-size: 12px !important;
}
@media (min-width: 2560px) {
  .font-xxsmall {
    font-size: 14.4px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxsmall {
    font-size: 17.28px !important;
  }
}
.font-xsmall {
  font-size: 13px !important;
}
@media (min-width: 2560px) {
  .font-xsmall {
    font-size: 15.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xsmall {
    font-size: 18.72px !important;
  }
}
.font-small {
  font-size: 14px !important;
}
@media (min-width: 2560px) {
  .font-small {
    font-size: 16.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-small {
    font-size: 20.16px !important;
  }
}
.font-medium {
  font-size: 16px !important;
}
@media (min-width: 2560px) {
  .font-medium {
    font-size: 19.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-medium {
    font-size: 23.04px !important;
  }
}
.font-large {
  font-size: 18px !important;
}
@media (min-width: 2560px) {
  .font-large {
    font-size: 21.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-large {
    font-size: 25.92px !important;
  }
}
.font-xlarge {
  font-size: 24px !important;
}
@media (min-width: 2560px) {
  .font-xlarge {
    font-size: 28.8px !important;
  }
}
@media (min-width: 3000px) {
  .font-xlarge {
    font-size: 34.56px !important;
  }
}
.font-xxlarge {
  font-size: 28px !important;
}
@media (min-width: 2560px) {
  .font-xxlarge {
    font-size: 33.6px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxlarge {
    font-size: 40.32px !important;
  }
}
.font-xxxlarge {
  font-size: 36px !important;
}
@media (min-width: 2560px) {
  .font-xxxlarge {
    font-size: 43.2px !important;
  }
}
@media (min-width: 3000px) {
  .font-xxxlarge {
    font-size: 51.84px !important;
  }
}
:root {
  --font-family: Roboto, sans-serif;
  --font-xxsmall: 12px;
  --font-xsmall: 13px;
  --font-small: 14px;
  --font-medium: 16px;
  --font-large: 18px;
  --font-xlarge: 24px;
  --font-xxlarge: 28px;
  --font-xxxlarge: 36px;
  --scale-factor-2560: 1.2;
  --scale-factor-3840: 1.2;
  --button-large: 50px;
  --button-medium: 45px;
  --button-small: 40px;
  --button-xsmall: 35px;
  --button-xxsmall: 30px;
  --header-height: 95px;
  --header-height-scrolled: 80px;
  --sidebar-width: 350px;
  --base-cover-radius: 50px;
  --base-tile-radius: 20px;
  --base-form-radius: 30px;
  --base-programme-tile-radius: 6px;
  --transition-function: cubic-bezier(0.02, 0.01, 0.47, 1);
  --transition-duration-xs: 0.15s;
  --transition-duration-sm: 0.25s;
  --transition-duration: 0.35s;
  --transition-duration-lg: 0.5s;
  --mini-details-z-index: 1100000;
  --player-z-index: 1054;
  --details-z-index: 9999999;
}
.cursor-pointer {
  cursor: pointer;
}
a,
a:visited {
  color: var(--highlight_primary);
}
.pg-all {
  padding: 50px;
}
@media screen and (max-width: 1368px) {
  .pg-all {
    padding: 35px;
  }
}
@media screen and (max-width: 768px) {
  .pg-all {
    padding: 20px;
  }
}
.pg-left {
  padding-left: 50px;
}
@media screen and (max-width: 1368px) {
  .pg-left {
    padding-left: 35px;
  }
}
@media screen and (max-width: 768px) {
  .pg-left {
    padding-left: 20px;
  }
}
.pg-right {
  padding-right: 50px;
}
@media screen and (max-width: 1368px) {
  .pg-right {
    padding-right: 35px;
  }
}
@media screen and (max-width: 768px) {
  .pg-right {
    padding-right: 20px;
  }
}
.pg-top {
  padding-top: 50px;
}
@media screen and (max-width: 1368px) {
  .pg-top {
    padding-top: 35px;
  }
}
@media screen and (max-width: 768px) {
  .pg-top {
    padding-top: 20px;
  }
}
.pg-bottom {
  padding-bottom: 50px;
}
@media screen and (max-width: 1368px) {
  .pg-bottom {
    padding-bottom: 35px;
  }
}
@media screen and (max-width: 768px) {
  .pg-bottom {
    padding-bottom: 20px;
  }
}
.mg-all {
  margin: 50px;
}
@media screen and (max-width: 1368px) {
  .mg-all {
    margin: 35px;
  }
}
@media screen and (max-width: 768px) {
  .mg-all {
    margin: 20px;
  }
}
.mg-left {
  margin-left: 50px;
}
@media screen and (max-width: 1368px) {
  .mg-left {
    margin-left: 35px;
  }
}
@media screen and (max-width: 768px) {
  .mg-left {
    margin-left: 20px;
  }
}
.mg-right {
  margin-right: 50px;
}
@media screen and (max-width: 1368px) {
  .mg-right {
    margin-right: 35px;
  }
}
@media screen and (max-width: 768px) {
  .mg-right {
    margin-right: 20px;
  }
}
.mg-top {
  margin-top: 50px;
}
@media screen and (max-width: 1368px) {
  .mg-top {
    margin-top: 35px;
  }
}
@media screen and (max-width: 768px) {
  .mg-top {
    margin-top: 20px;
  }
}
.mg-bottom {
  margin-bottom: 50px;
}
@media screen and (max-width: 1368px) {
  .mg-bottom {
    margin-bottom: 35px;
  }
}
@media screen and (max-width: 768px) {
  .mg-bottom {
    margin-bottom: 20px;
  }
}
h1 {
  font-size: 24px;
}
.min-width-50 {
  min-width: 50px;
}
.min-width-75 {
  min-width: 75px;
}
.min-width-100 {
  min-width: 100px;
}
.min-width-125 {
  min-width: 125px;
}
.min-width-150 {
  min-width: 150px;
}
.min-width-175 {
  min-width: 175px;
}
.min-width-200 {
  min-width: 200px;
}
.min-width-225 {
  min-width: 225px;
}
.min-width-250 {
  min-width: 250px;
}
.min-width-275 {
  min-width: 275px;
}
.min-width-300 {
  min-width: 300px;
}
.top-shadow {
  background-image:
    linear-gradient(
      to bottom,
      var(--background_primary),
      transparent);
}
.right-shadow {
  background-image:
    linear-gradient(
      to left,
      var(--background_primary),
      transparent);
}
.bottom-shadow {
  background-image:
    linear-gradient(
      to top,
      var(--background_primary),
      transparent);
}
.left-shadow {
  background-image:
    linear-gradient(
      to right,
      var(--background_primary),
      transparent);
}
.br-tile {
  border-radius: calc(var(--tile_border_radius) / 10 * 20px);
}
.br-form {
  border-radius: 18px;
}
.br-cover {
  border-radius: calc(var(--tile_border_radius) / 10 * 50px);
}
.br-circle {
  border-radius: 50%;
}
.uppercase {
  text-transform: uppercase;
}
.text-shadow {
  text-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
}
.bg-pri {
  background-color: var(--background_primary);
}
svg.fill path,
svg path.fill {
  stroke: transparent !important;
}
svg.stroke path,
svg path.stroke {
  fill: transparent !important;
}
svg path {
  stroke: var(--text_primary);
  fill: var(--text_primary);
}
svg.hover-highlight-primary:hover path {
  stroke: var(--highlight_primary);
  fill: var(--highlight_primary);
}
.main-container {
  margin-top: 125px;
  margin-bottom: 125px;
}
.line-clamp-1 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  line-clamp: 1;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-line-clamp: 1;
}
.line-clamp-2 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  line-clamp: 2;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-line-clamp: 2;
}
.line-clamp-3 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  line-clamp: 3;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-line-clamp: 3;
}
.line-clamp-4 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  line-clamp: 4;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-line-clamp: 4;
}
.line-clamp-5 {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  line-clamp: 5;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  display: -moz-box;
  -moz-box-orient: vertical;
  -moz-line-clamp: 5;
}
* {
  scrollbar-width: thin;
}
.min-width-150 {
  min-width: 150px;
}
.footer-wrapper {
  margin-top: 50px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background-color: var(--background_secondary);
  overflow-x: hidden;
}
.footer-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  padding: 30px 234px 40px;
}
.footer-col--logo {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 140px;
}
.footer-logo {
  max-width: 85px;
  height: 20px;
  object-fit: contain;
  object-position: left;
  margin-bottom: 8px;
}
.footer-copyright {
  font-size: 13px;
  opacity: 1;
  white-space: nowrap;
}
.footer-year {
  font-size: 13px;
  opacity: 1;
}
.footer-version {
  font-size: 13px;
  opacity: 1;
}
.footer-col {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 130px;
}
.footer-title {
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 6px;
}
.footer-title:empty::before {
  content: "\a0";
}
.footer-link {
  font-size: 13px;
  font-weight: 400;
  opacity: 0.6;
  color: var(--text_primary);
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.15s ease;
  min-height: 20px;
  line-height: 20px;
}
.footer-link:hover {
  opacity: 1;
}
.footer-inline-links {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 20px;
}
.footer-store-links {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.footer-store-link {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text_primary);
  opacity: 0.6;
  text-decoration: none;
  font-size: 13px;
  transition: opacity 0.15s ease;
}
.footer-store-link img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}
.footer-store-link:hover {
  opacity: 1;
}
.footer-social-links {
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
}
.footer-social-links a {
  display: flex;
  align-items: center;
  transition: opacity 0.15s ease;
  opacity: 0.6;
}
.footer-social-links a:hover {
  opacity: 1;
}
.footer-social-links img {
  width: 22px;
  height: 22px;
  object-fit: contain;
}
@media screen and (max-width: 1800px) {
  .footer-container {
    padding: 30px 140px 40px;
  }
}
@media screen and (max-width: 1600px) {
  .footer-container {
    padding: 30px 80px 40px;
  }
}
@media screen and (max-width: 1368px) {
  .footer-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    padding: 30px 7vw 40px;
    gap: 32px 30px;
  }
  .footer-col--logo {
    grid-column: 1;
    grid-row: 1;
  }
  .footer-col:nth-child(2) {
    grid-column: 2;
    grid-row: 1;
  }
  .footer-col:nth-child(3) {
    grid-column: 3;
    grid-row: 1;
  }
  .footer-col:nth-child(4) {
    grid-column: 1;
    grid-row: 2;
  }
  .footer-col:nth-child(5) {
    grid-column: 2;
    grid-row: 2;
  }
  .footer-col:last-child {
    grid-column: 3;
    grid-row: 2;
  }
}
@media screen and (max-width: 768px) {
  .footer-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: 30px 35px 40px;
    row-gap: 0;
    column-gap: 24px;
  }
  .footer-title:empty {
    display: none;
  }
  .footer-col--logo {
    grid-column: 1;
    grid-row: 1/3;
  }
  .footer-col:nth-child(2) {
    grid-column: 2;
    grid-row: 1;
  }
  .footer-col:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
    margin-top: 10px;
  }
  .footer-col:nth-child(4) {
    grid-column: 1;
    grid-row: 3;
    margin-top: 28px;
  }
  .footer-col:nth-child(5) {
    grid-column: 2;
    grid-row: 3;
    margin-top: 28px;
  }
  .footer-col:last-child {
    grid-column: 1/-1;
    grid-row: 4;
    margin-top: 28px;
  }
  .footer-col {
    width: 100%;
    min-width: auto;
  }
}
@media screen and (max-width: 576px) {
  .footer-container {
    padding: 24px 16px 32px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 0;
    column-gap: 16px;
  }
  .footer-title:empty {
    display: none;
  }
  .footer-col--logo {
    grid-column: 1;
    grid-row: 1/3;
  }
  .footer-col:nth-child(2) {
    grid-column: 2;
    grid-row: 1;
  }
  .footer-col:nth-child(3) {
    grid-column: 2;
    grid-row: 2;
    margin-top: 10px;
  }
  .footer-col:nth-child(4) {
    grid-column: 1;
    grid-row: 3;
    margin-top: 28px;
  }
  .footer-col:nth-child(5) {
    grid-column: 2;
    grid-row: 3;
    margin-top: 28px;
  }
  .footer-col:nth-child(6) {
    grid-column: 1/-1;
    grid-row: 4;
    margin-top: 28px;
  }
  .footer-col {
    width: 100%;
    min-width: auto;
  }
  .footer-col:nth-child(even) {
    align-items: flex-start;
    text-align: left;
  }
}
/*# sourceMappingURL=footer.component.css.map */
